import "./Header.css";

import {
    Search,
    ShoppingCart,
    User
} from "lucide-react";

function Header() {

    return (
        <header className="header">

            {/* =================================================
                FARMFOX LOGO
            ================================================= */}

            <div className="header__logo">

                <img
                    src="/logo_farmfox.jpeg"
                    alt="FarmFox"
                    className="farmfox-main-logo"
                />

                <span className="logo-tagline">
                    Premium Mithila Makhana
                </span>

            </div>


            {/* =================================================
                NAVIGATION
            ================================================= */}

            <nav className="header__nav">

                <a href="/">
                    <span>Shop</span>
                    <span className="arrow">▼</span>
                </a>

                <a href="/">
                    Collections
                </a>

                <a href="/">
                    Best Sellers
                </a>

                <a href="/">
                    Combos
                </a>

                <a href="/">
                    Gift Boxes
                </a>

            </nav>


            {/* =================================================
                HEADER ACTIONS
            ================================================= */}

            <div className="header__actions">

                {/* =========================
                    SEARCH
                ========================= */}

                <div className="search-box">

                    <input
                        type="text"
                        placeholder="Search Premium Makhana..."
                        aria-label="Search Premium Makhana"
                    />

                    <Search
                        className="search-icon"
                        size={19}
                    />

                </div>


                {/* =========================
                    USER
                ========================= */}

                <button
                    className="icon-btn"
                    aria-label="Account"
                >
                    <User size={20} />
                </button>


                {/* =========================
                    CART
                ========================= */}

                <button
                    className="cart-btn"
                    aria-label="Shopping Cart"
                >

                    <ShoppingCart
                        className="cart-icon"
                        size={18}
                    />

                    <span>
                        Cart
                    </span>

                </button>

            </div>

        </header>
    );
}

export default Header;